<ng-template #stammdatenTemplate>
  <div>
    <div sbbDialogTitle>
      <b>{{ 'app.view.dialogs.stammdaten-dialog.base-data' | translate }}</b>
    </div>
    <div sbbDialogContent>
      <table sbb-table [dataSource]="dataSource">
        <ng-container sbbColumnDef="betriebspunkt">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.operationalPoint' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            {{ element.betriebspunkt }}
          </td>
        </ng-container>
        <ng-container sbbColumnDef="haltezeit_I_P_V">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.ipv-stop-time' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="!element['HaltezeitIPV'].no_halt; else noHalt">
              {{ element["HaltezeitIPV"].haltezeit }}
            </div>
            <ng-template #noHalt> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="haltezeit_A">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.a-stop-time' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="!element['HaltezeitA'].no_halt; else noHalt">
              {{ element["HaltezeitA"].haltezeit }}
            </div>
            <ng-template #noHalt> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="haltezeit_B">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.b-stop-time' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="!element['HaltezeitB'].no_halt; else noHalt">
              {{ element["HaltezeitB"].haltezeit }}
            </div>
            <ng-template #noHalt> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="haltezeit_C">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.c-stop-time' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="!element['HaltezeitC'].no_halt; else noHalt">
              {{ element["HaltezeitC"].haltezeit }}
            </div>
            <ng-template #noHalt> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="haltezeit_D">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.d-stop-time' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="!element['HaltezeitD'].no_halt; else noHalt">
              {{ element["HaltezeitD"].haltezeit }}
            </div>
            <ng-template #noHalt> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="zaz">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.zaz' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="element.zaz !== 0; else noZAZ">
              {{ element.zaz }}
            </div>
            <ng-template #noZAZ> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="connection_time">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.connection-time' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="element.connection_time !== 0; else noHalt">
              {{ element.connection_time }}
            </div>
            <ng-template #noHalt> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="region">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.region' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="element.region !== ''; else noRegion">
              {{ element.region }}
            </div>
            <ng-template #noRegion> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="kategorie">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.category' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="element.kategorie !== ''; else noKategorie">
              {{ element.kategorie }}
            </div>
            <ng-template #noKategorie> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="filterableLabels">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.filterable-labels' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="element.filterableLabels.length !== 0; else noLabels">
              {{ element.filterableLabels }}
            </div>
            <ng-template #noLabels> — </ng-template>
          </td>
        </ng-container>
        <ng-container sbbColumnDef="pos">
          <th sbb-header-cell *sbbHeaderCellDef>{{ 'app.view.dialogs.stammdaten-dialog.position' | translate }}</th>
          <td sbb-cell *sbbCellDef="let element">
            <div *ngIf="element.pos !== undefined; else noPos">
              {{ element.pos.getX() }} <br />
              {{ element.pos.getY() }}
            </div>
            <ng-template #noPos> — </ng-template>
          </td>
        </ng-container>

        <tr sbb-header-row *sbbHeaderRowDef="displayedColumns"></tr>
        <tr sbb-row *sbbRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div sbbDialogActions>
      <button sbb-alt-button sbbDialogClose [sbbDialogClose]="false">
        {{ 'app.view.dialogs.stammdaten-dialog.close' | translate }}
      </button>
    </div>
  </div>
</ng-template>
